import React from 'react'
import { Button } from '@/components/ui/button'
import { LucideIcon } from 'lucide-react'

interface EmptyStateProps {
  icon?: LucideIcon
  title: string
  description?: string
  action?: React.ReactNode
  className?: string
}

export const EmptyState = ({ 
  icon: Icon, 
  title, 
  description,
  action,
  className = ''
}: EmptyStateProps) => {
  return (
    <div className={`bg-white rounded-lg shadow-sm border p-6 md:p-12 text-center ${className}`}>
      {Icon && (
        <Icon className="w-16 h-16 text-gray-400 mx-auto mb-4" />
      )}
      <p className="text-gray-600 font-medium mb-2">{title}</p>
      {description && (
        <p className="text-sm text-gray-500 mb-6">{description}</p>
      )}
      {action && <div className="mt-4">{action}</div>}
    </div>
  )
}

